<template>
  <main-sidebar :name="name" :title="$t('edit')">
    <div class="p-4">
      <div class="vx-row">
        <div class="vx-col w-full mt-2">
          <vs-input
            :label="$t('no_order') | capitalize"
            class="w-full"
            v-model="loadOrder.no_order"
            disabled
          />
        </div>
        <div class="vx-col w-full mt-2">
          <vs-input
            :label="$t('plates') | capitalize"
            class="w-full"
            v-model="loadOrder.plates"
            disabled
          />
        </div>
        <div class="vx-col w-full mt-2">
          <label for="" class="label-text"
            >{{ $t('transporter') | capitalize }}
          </label>
          <v-select
            v-model="loadOrder.transporter_id"
            class="w-full"
            label="transporter_code"
            :placeholder="$t('transporter') | capitalize"
            :options="transporters"
            :reduce="(item) => item.id"
            :clearable="false"
            @input="setTrailer"
          />
        </div>
        <div class="vx-col w-full mt-2">
          <label for="" class="label-text"
            >{{ $t('trailer') | capitalize }}
          </label>
          <v-select
            v-model="loadOrder.trailer_id"
            class="w-full"
            label="name"
            :placeholder="$t('trailer') | capitalize"
            :options="trailersLis"
            :reduce="(item) => item.id"
            :clearable="false"
            @input="setPlates"
          />
        </div>
        <div class="vx-col w-full mt-2">
          <label for="" class="label-text"
            >{{ $t('comments') | capitalize }}
          </label>
          <vs-textarea class="w-full" v-model="loadOrder.comments" />
        </div>
      </div>
    </div>

    <div class="mx-4" slot="footer">
      <vs-button color="primary" type="filled" class="mr-6" :disabled="disabled" @click="submit">
        {{ $t('save') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="close">
        {{ $t('cancel') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import loading from '@/mixins/Loading'
import loadOrder from '@/http/requests/loadOrder'
import validate from '@/mixins/Validate'
import vSelect from 'vue-select'
export default {
  components: {
    MainSidebar,
    'v-select': vSelect,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return (
        this.loading.submit
      )
    },
    trailersLis() {
      return this.trailers.filter(i => i.transporter_id == this.loadOrder.transporter_id)
    },
    disabled(){
      return this.loadOrder.trailer_id === ''
    }

  },
  data: () => ({
    name: 'edit-load-order',
    loadOrder: {},
    loading: {
      submit: false,
      transporters: false,
      trailers: false,
    },
    transporters: [],
    trailers: [],
  }),
  methods: {
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    submit() {
      this.loading.submit = true
      loadOrder
        .updateLoadOrder(this.loadOrder)
        .then ( res => {
          this.loading.submit = false
          this.$emit('submit')
          this.close()
        })
        .catch ( res => {
          this.displayErrors(res)
          this.loading.submit = false
        })
    },
    getTransporters() {
      loadOrder
        .getTransporters()
        .then((res) => {
          this.transporters = res.data.items
        })
        .catch((res) => {
        })
    },
    getTrailers() {
      loadOrder
        .getTrailers({})
        .then((res) => {
          this.trailers = res.data.items
        })
        .catch((res) => {
        })
    },
    setPlates(){
      let trailer = this.trailers.find( i => i.id === this.loadOrder.trailer_id)
        this.loadOrder.plates = trailer.plates
        
    },
    setTransporter(){
        let trailer = this.trailers.find( i => i.id === this.loadOrder.trailer_id)
        this.loadOrder.transporter_id = trailer.transporter_id
    },
    setTrailer(){
      this.loadOrder.trailer_id = ''
      if(this.trailersLis.length > 0){
        this.loadOrder.trailer_id = this.trailersLis[0].id
      }
    }

    
  },
  mixins: [loading, validate],
  mounted() {
    this.getTransporters()
    this.getTrailers()
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.loadOrder = Object.assign({}, this.data)
        this.setPlates()
        this.setTransporter()
        }
      },
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
  }
}
</script>

<style>
.label-text {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.7);
  padding-left: 5px;
}
</style>